export default "__VITE_ASSET__gEyKhj8l__"